module.exports = __webpack_public_path__ + "static/jordan-83a51734a29104e682d8004c1a90bb88.jpg";